import { styled } from "styled-components";
import { Button } from "antd";

export const StyledMain = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledContainer = styled.main`
  width: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  height: ${({ $height }) => $height};
  overflow-y: auto;

  @media (max-width: 900px) {
    height: ${({ $isShopifyApp }) =>
      $isShopifyApp ? "100%" : "calc(100% - 64px)"};
    padding: 0 20px;
  }

  @media (max-width: 650px) {
    padding: 0 10px;
  }
`;

export const Wrapper = styled.div``;

export const StyledButton = styled(Button)`
  position: absolute;
  z-index: 99;
  right: 0;
  font-weight: 500;
  background: ${({ theme }) => theme.pallette.blue.main};
  color: ${({ theme }) => theme.pallette.white.main};
  border: none;
  border-radius: 0 0 6px 6px;
  margin-right: 10px;
  transition: none;

  svg {
    margin-right: 10px;

    path {
      stroke: ${({ theme }) => theme.pallette.white.main};
    }
  }

  &:hover {
    color: ${({ theme }) => theme.pallette.blue.light} !important;

    svg {
      path {
        stroke: ${({ theme }) => theme.pallette.blue.light} !important;
      }
    }
  }
`;
